import React, { useEffect, useState } from "react";
import "./Leftmost_Toolbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faExpand,
  faHome,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Leftmost_Toolbar = (props) => {
  const [activeIndex, setActiveIndex] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (!props.showCol2) {
      setActiveIndex(null);
    }
  }, [props.showCol2]);

  return (
    <>
      <div className="Leftmost_Toolbar">
        <div className="overlay_div">
          <div
            className={`tool_icon_holder ${activeIndex === 0 ? "active" : ""}`}
            onClick={() => {
              setActiveIndex(0);
              navigate("/my-account");
            }}
          >
            <FontAwesomeIcon icon={faHome} className="tool_icon" />
          </div>

          <p className="overlay_text">Home</p>
        </div>

        <div className="overlay_div">
          <div
            className={`tool_icon_holder ${activeIndex === 1 ? "active" : ""}`}
            onClick={() => {
              setActiveIndex(1);
              props?.setSelectedTab(1);
              props?.handleOpen();
              props?.handleShowCol2OffCanvashandle();
            }}
          >
            <FontAwesomeIcon icon={faListUl} className="tool_icon" />
          </div>
          <p className="overlay_text">Crypto</p>
        </div>

        {/* <div className="overlay_div">
          <div
            className={`tool_icon_holder ${activeIndex === 2 ? "active" : ""}`}
            onClick={() => {
              setActiveIndex(2);
              props?.setSelectedTab(2);
              props?.handleOpen();
              props?.handleShowCol2OffCanvashandle();
            }}
          >
            <FontAwesomeIcon icon={faCalendar} className="tool_icon" />
          </div>
          <p className="overlay_text">Economic Calendar</p>
        </div> */}

        <div
          className={`tool_icon_holder full_screen_icon_holder d-lg-none ${
            activeIndex === 4 ? "active" : ""
          }`}
          onClick={() => {
            setActiveIndex(4);
            props?.handleOpen();
            props?.handleShowCol4OffCanvashandle();
          }}
        >
          <FontAwesomeIcon icon={faExpand} className="tool_icon" />
        </div>
      </div>
    </>
  );
};

export default Leftmost_Toolbar;
